/* eslint-disable react/require-default-props */
import React from "react";
import { FieldProps } from "formik";
import { cx } from "@emotion/css";
import formGroupStyles from "../css/formgroup.module.css";

interface OtherProps {
  label: string;
  min?: number;
  max?: number;
}

type FieldTextPercentageProps = FieldProps & OtherProps;

const FieldTextPercentage = ({
  field, // { name, value, onChange, onBlur }
  form: { touched, errors, setFieldValue, handleChange, setFieldTouched },
  label,
  min = 1,
  max = 99
}: FieldTextPercentageProps) => {
  const fieldClasses = cx(
    formGroupStyles["form-group"],
    touched[field.name] && errors[field.name] ? formGroupStyles.error : ""
  );

  return (
    <div className={fieldClasses}>
      <label htmlFor={field.name}>{label}</label>
      <div>
        <div>
          <input
            className={formGroupStyles["input-group"]}
            style={{ width: "15%" }}
            type="number"
            spellCheck="false"
            min={1}
            max={99}
            value={field.value}
            id={field.name}
            onChange={e => {
              handleChange(e);
            }}
            onKeyDown={e => {
              if (e.key === "-" || e.key === ".") {
                e.preventDefault();
              }

              const currentValue = e.currentTarget.value + e.key;
              const parsedNumber = parseInt(currentValue, 10);

              if (!Number.isNaN(parsedNumber) && parsedNumber > max) {
                e.preventDefault();
              }
            }}
            onBlur={e => {
              setFieldTouched(field.name);
              const parsedNumber = parseInt(e.currentTarget.value, 10);
              setFieldValue(
                field.name,
                parsedNumber ? parsedNumber.toString() : ""
              );
            }}
          />
          <span> %</span>
        </div>
        <div className={formGroupStyles["error-messages"]}>
          {touched[field.name] && errors[field.name] && (
            <div id={`${field.name}ErrorMessage`}>
              {errors[field.name] as React.ReactNode}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default FieldTextPercentage;
